import { formatDate, formatNumber, weekdayShort } from './format';

// The LightSpeed sync reports every expected opening day in the recent past
// that had no receipts, with the receipt count after the run (`after`, null on
// a dry run). One short line per day: filled, unchanged, or confirmed empty in
// LightSpeed (the café was closed). Shared by the top-bar Sync button and the
// Data page.
export function gapLines(gaps, t) {
  return (gaps || []).map((g) => {
    const day = `${weekdayShort(g.weekday_nl)} ${formatDate(g.date)}`;
    if (g.after == null) return `${day}: ${formatNumber(g.receipts)} ${t('bonnen')}`;
    if (g.after === 0) return `${day}: ${t('geen verkopen in LightSpeed')}`;
    if (g.after > g.receipts) return `${day}: ${t('aangevuld')} (${formatNumber(g.after)} ${t('bonnen')})`;
    return `${day}: ${formatNumber(g.after)} ${t('bonnen')}, ${t('niets nieuws')}`;
  });
}
